import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import { NotificationOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import EmployeeManagement from '../EmployeeManagement/EmployeesManagement';
import Secretary from '../Seceretary/Seceretary';
import Marketer from '../Marketeer/Marketeer';

const Staff = () => {
    const [activeTab, setActiveTab] = useState('employees');

    const tabItems = [
        {
            key: 'employees',
            label: (
                <span className="flex items-center gap-2">
                    <TeamOutlined />
                    Employees
                </span>
            ),
            children: <EmployeeManagement />,
        },

        {
            key: 'secretaries',
            label: (
                <span className="flex items-center gap-2">
                    <UserOutlined />
                    Secretaries
                </span>
            ),
            children: <Secretary />,
        },
        {
    key: 'marketers',
    label: (
        <span className="flex items-center gap-2">
            <NotificationOutlined />
            Marketers
        </span>
    ),
    children: <Marketer />,
}
    ];

    return (
        <div className="min-h-screen bg-[#F7FCFD]">
            <div className="md: p-2">
                <Card className="shadow-lg border-0 bg-white/90 backdrop-blur-sm mt-6">
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                    />
                </Card>
            </div>
        </div>
    );
};

export default Staff;